<template>
  <div class="koc-block koc-purchase-product-single-block">
    <div class="koc-full">
      <div class="koc-product">
        <h2>
          <b>{{ product.title }}</b>
          {{ product.description }}
          <template v-if="!product.cta">
            | {{ formatPrice(product.product.price) }}
          </template>
        </h2>
        <h4>
          <template v-if="product.duration">
            {{ formatPrice(product.product.price) }}/{{ product.duration }}
          </template>
          <span v-if="product.cta">
            |
            <b>{{ product.cta }}</b>
          </span>
        </h4>
        <p v-if="product.recurring">
          <i>{{ product.recurring }}</i>
        </p>
      </div>
    </div>
  </div>
</template>

<script src="./product-single.js"></script>
<style lang="scss" scoped src="./product-single.scss"></style>